import React, { useEffect, useState, useReducer } from "react";
import {
  Row,
  Col,
  Select,
  Button,
  Popconfirm,
  Tooltip,
  Table,
  Input,
  Form,
  Modal,
  Divider,
  Typography,
  InputNumber,
  DatePicker,
  notification,
  Card,
  message,
  Checkbox,
} from "antd";
import {
  CloseCircleFilled,
  DeleteFilled,
  ExportOutlined,
  PlusCircleOutlined,
  SyncOutlined,
  EyeOutlined,
} from "@ant-design/icons";
import * as XLSX from "xlsx";
import { BpiService } from "../Services/BpiService";
import { ExerciceDocService } from "../Services/ExerciceDocService";
import TableDOc from "./TableDoc";
import { AdherentsService } from "../Services/AdherentsService";
import { ParticipantsIpmService } from "../Services/ParticipantsIpmService";
import { SpecialitesService } from "../Services/SpecialitesService";
import { TypesBenefsService } from "../Services/TypesBenefsServices";
import { ListFournisService } from "../Services/ListFournisService";
import moment from "moment";
import dayjs from "dayjs";
import { PrestationsService } from "../Services/PrestationsService";

const { confirm } = Modal;
const { Option } = Select;
const { Title, Text } = Typography;

const initialState = {
  tableData: [],
  selectedOption: "KO",
  selectedTypeDoc: "BCI",
  showAdditionalColumns: false,
  loading: false,
  isExportModalVisible: false,
  selectedColumns: [],
  filteredData: [],
  selectedYear: new Date().getFullYear().toString(),
  years: [],
  addedRows: [],
  participantsData: null,
  isTableVisible: false,
  medicamentsData: null,
  benefsData: null,
  isSaisirMedicamentClicked: false,
  specialitesData: null,
  isEdit: false,
  prescripteursData: [],
  pharmaciesData: [],
  isMatriculeSelected: false,
  isBeneficiaireSelected: false,
  beneficiaires: [],
  isDateSelected: false,
  selectedRowData: null,
  addedMedicaments: [],
  isPrescripteurSelectEnabled: false,
  isPrescripteurSelect: false,
  adherents: [],
  fournisseurs: null,
  allBeneficiaires: [],
  beneficiaires: [],
  isModalVisible: false,
  ipm: 0,
  part: 0,
};

const reducer = (state, action) => {
  switch (action.type) {
    case "SET_STATE":
      return { ...state, ...action.payload };

    default:
      return state;
  }
};

const BonsOptique = () => {
  const bpiService = new BpiService();
  const exerciceDocService = new ExerciceDocService();
  const adherentsService = new AdherentsService();
  const participantsIpmService = new ParticipantsIpmService();
  const specialistesService = new SpecialitesService();
  const typesBenefsService = new TypesBenefsService();
  const fournisseurService = new ListFournisService();
  const prestationService = new PrestationsService();

  const userProfil = localStorage.getItem("profil");

  const [isParticipantInactive, setIsParticipantInactive] = useState(false);
  const [selectedParticipant, setSelectedParticipant] = useState(null);
  const [prixUnitaireMap, setPrixUnitaireMap] = useState({});

  const [isBonManuel, setIsBonManuel] = useState(false); // État pour la case à cocher "Bon Manuel"

  // Fonction pour gérer le changement de la case à cocher
  const handleBonManuelChange = (e) => {
    setIsBonManuel(e.target.checked);
  };
  const [state, dispatch] = useReducer(reducer, initialState);
  const [form] = Form.useForm();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const yearsData = await exerciceDocService.getAllExercicesDoc();
        dispatch({ type: "SET_STATE", payload: { years: yearsData } });
        // await fetchDataByOption(state.selectedOption);
      } catch (error) {
        console.error("Erreur lors de la récupération des données :", error);
      }
    };

    fetchData();
  }, [state.selectedYear, state.selectedOption, state.refreshTable]);

  useEffect(() => {
    fetchDataByOption(state.selectedOption);
  }, [
    state.selectedYear,
    state.selectedOption,
    state.selectedTypeDoc,
    state.refreshTable,
  ]);

  const userRoleName = localStorage.getItem("role_name");

  const fetchDataByOption = async (option) => {
    dispatch({ type: "SET_STATE", payload: { loading: true } });
    try {
      const data = await bpiService.getAllBci(
        state.selectedTypeDoc,
        option,
        state.selectedYear
      );
      const filteredData =
        userRoleName === "Point_Focal"
          ? data.filter((item) => item.user_id === userId)
          : data;
      const shouldShowAdditionalColumns = option === "OK";

      dispatch({
        type: "SET_STATE",
        payload: {
          // tableData: data,
          tableData: filteredData,
          filteredData: filteredData,
          loading: false,
          showAdditionalColumns: shouldShowAdditionalColumns,
        },
      });
    } catch (error) {
      dispatch({ type: "SET_STATE", payload: { loading: false } });
      console.error("Erreur lors de la récupération des données :", error);
    }
  };

  useEffect(() => {
    dispatch({ type: "SET_STATE", payload: { filteredData: state.tableData } });
  }, [state.tableData, state.refreshTable]);

  const handleSelectChange = (value) => {
    dispatch({ type: "SET_STATE", payload: { selectedOption: value } });
  };

  const handleYearChange = (value) => {
    dispatch({ type: "SET_STATE", payload: { selectedYear: value } });
  };

  const handleRefresh = () => {
    dispatch({
      type: "SET_STATE",
      payload: { refreshTable: !state.refreshTable },
    });
  };

  const handleSearch = (value) => {
    const filtered = state.tableData.filter((item) =>
      Object.values(item).some(
        (val) =>
          val && val.toString().toLowerCase().includes(value.toLowerCase())
      )
    );

    dispatch({ type: "SET_STATE", payload: { filteredData: filtered } });
  };

  const handleDeleteline = async (numdoc) => {
    try {
      confirm({
        title: "Êtes-vous sûr de vouloir supprimer cette prestation ?",
        okText: "Oui",
        cancelText: "Non",
        onOk: async () => {
          try {
            await bpiService.deleteDoc(numdoc);
            const updatedData = state.filteredData.filter(
              (item) => item.numdoc !== numdoc
            );
            dispatch({
              type: "SET_STATE",
              payload: { filteredData: updatedData },
            });
          } catch (error) {
            console.error("Erreur lors de la suppression du document :", error);
          }
        },
        onCancel() {
          // Annulation
        },
      });
    } catch (error) {
      console.error(
        "Erreur lors de la confirmation de la suppression :",
        error
      );
    }
  };
  const handleTauxPc = async (payload) => {
    try {
      const tauxPCData = await prestationService.addTauxPC(payload);
      return tauxPCData;
    } catch (error) {
      console.error("Erreur lors de l'appel de l'API tauxPC :", error);
      throw error; // Relancer l'erreur pour la gérer dans handleAddRow
    }
  };

  const handleAddRow = async () => {
    const values = form.getFieldsValue();
    const {
      qte,
      prix_unitaire,
      remise,
      codeacte,
      codefourn,
      codepresc,
      codesoc,
      datepresc,
      matribenef,
      matripart,

      typebenef,
    } = values;

    // Assurer que les valeurs par défaut sont prises en compte
    const quantity = qte !== undefined ? qte : 1;
    const unitPrice = prix_unitaire !== undefined ? prix_unitaire : 0;

    const freel = quantity * unitPrice;

    if (state.addedMedicaments.includes(codeacte)) {
      notification.warning({
        message: "Duplication",
        description: "Ce médicament a déjà été ajouté à la table.",
      });
      return;
    }

    const selectedActe = state.medicamentsData.find(
      (acte) => acte.codeacte === codeacte
    );
    if (!selectedActe) {
      message.error("Acte sélectionné non trouvé.");
      return;
    }
    const medicament = state.medicamentsData.find(
      (med) => med.codeacte === codeacte
    );
    const exclus = medicament ? medicament.exclus : false;
    // Ajouter les champs manquants
    const completeActe = {
      ...selectedActe,
      ajustmt: 0,
      fexclus: 0,
      freel: freel,
      numligne_acte: selectedActe.codeacte,
      qpassur: 0,
      qpmut: 0,
      tarif: freel,
      ticket: 0,
      qte: quantity,
    };

    const newRow = {
      ...completeActe,
      exclus,
      numero: state.addedRows.length + 1,
      prix_unitaire: prixUnitaireMap[state.addedRows.length + 1] || 0,
    };

    const newAddedRows = [...state.addedRows, newRow];
    const newPayload = {
      actes: newAddedRows,
      categprof: "E13A",
      codefourn: codefourn,
      codepresc: codepresc,
      codeprest: completeActe.codeprest,
      codesoc: codesoc,
      datepresc: datepresc ? datepresc.format("YYYY-MM-DD") : null,
      matribenef: matribenef,
      matripart: matripart,
      montant_remise: remise,
      montdoc: newAddedRows.reduce((sum, row) => sum + row.freel, 0),
      natprest: completeActe.codeprest,
      qpmut: 0,
      remb_integral: false,
      ticket: 0,
      typebenef: typebenef,
      typedoc: "BCI",
    };

    try {
      const tauxPCData = await handleTauxPc(newPayload);

      dispatch({
        type: "SET_STATE",
        payload: {
          addedRows: newAddedRows,
          addedMedicaments: [...state.addedMedicaments, codeacte],
          isTableVisible: true,
          newPayload,
          ipm: tauxPCData.qpmut || 0,
          part: tauxPCData.ticket || 0,
        },
      });

      form.setFieldsValue({
        qteTotal: isNaN(values.qteTotal)
          ? quantity
          : values.qteTotal + quantity,
      });

      form.resetFields(["codeacte", "qte", "prix_unitaire"]);

      notification.success({
        message: "Ligne ajoutée",
        description: "La ligne a été ajoutée avec succès.",
      });

      return newAddedRows; // Return the updated rows
    } catch (error) {
      console.error("Erreur lors de l'ajout de la ligne :", error);
      notification.error({
        message: "Erreur",
        description: "Une erreur est survenue lors de l'ajout de la ligne.",
      });
      return state.addedRows; // Return the existing rows if there's an error
    }
  };

  const handleDelete = async (record) => {
    const updatedRows = state.addedRows.filter(
      (row) => row.numero !== record.numero
    );
    const updatedMedicaments = state.addedMedicaments.filter(
      (codeacte) => codeacte !== record.codeacte
    );

    const newPayload = {
      ...state.newPayload,
      actes: updatedRows,
      montdoc: updatedRows.reduce((sum, row) => sum + row.freel, 0),
    };

    try {
      // Recalculez les valeurs IPM et PART
      const tauxPCData = await handleTauxPc(newPayload);

      dispatch({
        type: "SET_STATE",
        payload: {
          addedRows: updatedRows,
          addedMedicaments: updatedMedicaments,
          isTableVisible: updatedRows.length > 0,
          newPayload,
          ipm: tauxPCData.qpmut || 0,
          part: tauxPCData.ticket || 0,
        },
      });

      notification.success({
        message: "Ligne supprimée",
        description: "La ligne a été supprimée avec succès.",
      });
    } catch (error) {
      console.error(
        "Erreur lors de la mise à jour des valeurs IPM et PART :",
        error
      );
      notification.error({
        message: "Erreur",
        description:
          "Une erreur est survenue lors de la suppression de la ligne.",
      });
    }
  };

  const handleClearTable = () => {
    dispatch({
      type: "SET_STATE",
      payload: { addedRows: [], addedMedicaments: [] },
    });
  };

  const handleMedoc = (codespe) => {
    dispatch({
      type: "SET_STATE",
      payload: {
        isSaisirMedicamentClicked: !!codespe,
      },
    });
  };

  const fetchMedoc = async (codespe) => {
    try {
      const medicaments = await participantsIpmService.getOptiqueList(codespe);
      dispatch({
        type: "SET_STATE",
        payload: {
          medicamentsData: medicaments,
          isSaisirMedicamentClicked: !!codespe,
        },
      });
    } catch (error) {
      console.error("Erreur lors de la récupération des adhérents :", error);
    }
  };
  const handleDatePrescChange = (value) => {
    dispatch({
      type: "SET_STATE",
      payload: { isDateSelected: !!value },
    });
    fetchMedoc();
  };

  const handleFournisseurChange = async (value) => {
    try {
      // const allFournisseurs = await fournisseurService.getAllListFournis();
      const prescripteurs = state.fournisseurs.filter(
        (fournisseur) => fournisseur.codespe === value
      );
      dispatch({
        type: "SET_STATE",
        payload: {
          prescripteursData: prescripteurs,
          isPrescripteurSelectEnabled: !!value,
        },
      });
    } catch (error) {
      console.error(
        "Erreur lors de la récupération des prescripteurs :",
        error
      );
    }
  };

  const handleMatPartChange = async (value) => {
    try {
      const participantDetails = await participantsIpmService.getOneParticipant(
        value
      );

      if (participantDetails.suspension_part === "S") {
        setSelectedParticipant(participantDetails);
        setIsParticipantInactive(true);
        return;
      }

      if (participantDetails.suspension_adht) {
        Modal.confirm({
          title: "Société suspendue!",
          content:
            "Voulez-vous confirmer cette opération malgré la suspension?",
          okText: "Valider",
          cancelText: "Annuler",
          onOk: async () => {
            // Continue l'action si "Valider" est cliqué
            proceedWithMatPartChange(value, participantDetails);
          },
          onCancel: () => {
            // Réinitialise la sélection si "Annuler" est cliqué
            form.resetFields(["matripart"]);
          },
        });
        return;
      }

      proceedWithMatPartChange(value, participantDetails);
    } catch (error) {
      notification.error({
        message: "Erreur",
        description:
          "Erreur lors de la récupération des données du participant",
      });
    }
  };

  // Fonction pour exécuter les actions après validation
  const proceedWithMatPartChange = async (value, participantDetails) => {
    try {
      const benefData = await participantsIpmService.getBenefParticipant(value);
      dispatch({
        type: "SET_STATE",
        payload: {
          isMatriculeSelected: true,
          allBeneficiaires: benefData,
          beneficiaires: benefData,
          isBeneficiaireSelected: false,
          participantDetails,
        },
      });
      form.setFieldsValue({
        codetype: undefined,
        matribenef: undefined,
      });
    } catch (error) {
      notification.error({
        message: "Erreur",
        description: "Erreur lors de la récupération des bénéficiaires",
      });
    }
  };

  const fetchTypeBenef = async () => {
    try {
      const typeBenefData = await typesBenefsService.getAllTypesBenefs();
      dispatch({ type: "SET_STATE", payload: { benefsData: typeBenefData } });
    } catch (error) {
      console.error("Erreur lors de la récupération des adhérents :", error);
    }
  };

  const handleTypeBenefChange = async (value) => {
    try {
      const filteredBeneficiaires = state.allBeneficiaires.filter(
        (beneficiaire) => beneficiaire.codebenef === value
      );

      if (filteredBeneficiaires.length === 0) {
        form.setFieldsValue({
          matribenef: undefined,
        });
        dispatch({
          type: "SET_STATE",
          payload: { isBeneficiaireSelected: false },
        });
      } else {
        const matribenef = filteredBeneficiaires[0].matribenef;
        const verifOptique = await participantsIpmService.getVerifOptique(
          matribenef);

        console.log(verifOptique);

        if (verifOptique.verif === 'Doublon') {
          notification.error({
            message: "Erreur",
            description: "Un Bon Optique est deja etabli pour ce bénéficiaire",
          });
          form.setFieldsValue({
            matribenef: undefined,
          });
          dispatch({
            type: "SET_STATE",
            payload: { isBeneficiaireSelected: false },
          });
        } else if (verifOptique.verif === 'Delai') {
          Modal.confirm({
            title: "Délai de prise en charge optique non épuisé! pour ce bénéficiaire : " + matribenef,
            content: "Voulez-vous continuer?",
            okText: "Valider",
            cancelText: "Annuler",
            onOk: () => {
              dispatch({
                type: "SET_STATE",
                payload: {
                  beneficiaires: filteredBeneficiaires,
                  isBeneficiaireSelected: true,
                  remb_integral: true,
                },
              });
              form.setFieldsValue({
                matribenef: matribenef,
                remb_integral: true,
              });
              onChangeMatribenef(matribenef);
            },
            onCancel: () => {
              form.setFieldsValue({
                matribenef: undefined,
              });
              dispatch({
                type: "SET_STATE",
                payload: { isBeneficiaireSelected: false },
              });
            },
          });
        } else if (verifOptique.verif === 'OK') {
          dispatch({
            type: "SET_STATE",
            payload: {
              beneficiaires: filteredBeneficiaires,
              isBeneficiaireSelected: true,
              remb_integral: false,
            },
          });
          form.setFieldsValue({
            matribenef: matribenef,
            remb_integral: false,
          });
          onChangeMatribenef(matribenef);
        }
      }
    } catch (error) {
      console.error("Erreur lors du filtrage des bénéficiaires :", error);
    }
  };

  const fetchFournis = async () => {
    try {
      const allFournisseurs = await fournisseurService.getAllListFournis();
      dispatch({
        type: "SET_STATE",
        payload: { fournisseurs: allFournisseurs },
      });
      const pharmacies = allFournisseurs.filter((fournisseur) =>
        fournisseur.numFourn.startsWith("04")
      );
      dispatch({ type: "SET_STATE", payload: { pharmaciesData: pharmacies } });
    } catch (error) {
      console.error(
        "Erreur lors de la récupération des prescripteurs :",
        error
      );
    }
  };

  useEffect(() => {
    fetchFournis();
  }, []);

  const handleFournisChange = (value) => {
    dispatch({ type: "SET_STATE", payload: { isPrescripteurSelect: !!value } });
  };

  const fetchAdherents = async () => {
    try {
      const adherentsData = await adherentsService.getAllAdherents();

      // Filtrer les adhérents pour exclure ceux qui ont suspension_adht à true
      const filteredAdherents = adherentsData.filter(
        (adherent) => !adherent.suspension_adht
      );

      dispatch({
        type: "SET_STATE",
        payload: { adherents: filteredAdherents },
      });
    } catch (error) {
      notification.error({
        message: "Erreur",
        description: "Erreur lors de la récupération des adhérents",
      });
    }
  };

  const handleSocieteChange = async (value) => {
    try {
      let participantsData;

      if (!state.isEdit) {
        participantsData = await participantsIpmService.getOneListtParticipant(
          value
        );
      } else {
        participantsData = await participantsIpmService.getOneEtParticipant(
          value
        );
      }

      dispatch({
        type: "SET_STATE",
        payload: { participantsData: participantsData },
      });
    } catch (error) {
      console.error(
        "Erreur lors de la récupération des données du participant :",
        error
      );
    }
  };

  const fetchSpecialite = async () => {
    try {
      const specialites = await specialistesService.getAllSpecialites();
      dispatch({
        type: "SET_STATE",
        payload: { specialitesData: specialites },
      });
    } catch (error) {
      console.error("Erreur lors de la récupération des adhérents :", error);
    }
  };

  const handleOpenModal = (isManual = false) => {
    fetchAdherents();
    fetchTypeBenef();
    fetchFournis();
    fetchSpecialite();
    //fetchMedoc();
    setIsBonManuel(isManual);
    dispatch({ type: "SET_STATE", payload: { isModalVisible: true } });
  };

  const handleCloseModal = () => {
    form.resetFields();
    setIsBonManuel(false);
    dispatch({
      type: "SET_STATE",
      payload: {
        isTableVisible: false,
        isPrescripteurSelectEnabled: false,
        isPrescripteurSelect: false,
        isSaisirMedicamentClicked: false,
        isMatriculeSelected: false,
        isBeneficiaireSelected: false,
        isBonManuel: false,
        isDateSelected: false,
        isModalVisible: false,
        isEdit: false,
        addedRows: [],
        addedMedicaments: [],
        ipm: 0,
        part: 0,
        newPayload: null,
        participantsData: null,
        selectedRowData: null,
      },
    });
  };

  const handleCloseModalValid = () => {
    form.resetFields();
    dispatch({
      type: "SET_STATE",
      payload: {
        isTableVisible: false,
        isPrescripteurSelectEnabled: false,
        isPrescripteurSelect: false,
        isSaisirMedicamentClicked: false,
        isMatriculeSelected: false,
        isBeneficiaireSelected: false,
        isDateSelected: false,

        isEdit: false,
        addedRows: [],
        addedMedicaments: [],
        ipm: 0,
        part: 0,
        newPayload: null,
        participantsData: null,
        selectedRowData: null,
      },
    });
  };

  const onChangeMatribenef = async (value) => {
    dispatch({ type: "SET_STATE", payload: { matribenef: value } });

    const verifOptique = await participantsIpmService.getVerifOptique(value);

    if (verifOptique.verif === 'Doublon') {
      notification.error({
        message: "Erreur",
        description: "Un Bon Optique est deja etabli pour ce bénéficiaire",
      });
      form.setFieldsValue({
        matribenef: undefined,
      });
      dispatch({ type: "SET_STATE", payload: { remb_integral: false } });
    } else if (verifOptique.verif === 'Delai') {
      //afficher le modal de confirmation
      Modal.confirm({
        title: "Délai de prise en charge optique non épuisé! pour ce bénéficiaire : " + value,
        content: "Voulez-vous continuer?",
        okText: "Valider",
        cancelText: "Annuler",
        onOk: () => {
          dispatch({ type: "SET_STATE", payload: { remb_integral: true } });
        },
        onCancel: () => {
          dispatch({ type: "SET_STATE", payload: { remb_integral: false } });
        },
      });
    } else if (verifOptique.verif === 'OK') {
      dispatch({ type: "SET_STATE", payload: { remb_integral: false } });
    }
  };

  const handleEdit = async (record) => {
    dispatch({ type: "SET_STATE", payload: { isEdit: true } });
    dispatch({ type: "SET_STATE", payload: { isModalVisible: true } });

    try {
      const [
        details,
        adherentsData,
        participantsData,
        benefData,
        benefsData,
        specialites,
        prescripteursData,
        pharmaciesData,
        medicamentsData,
      ] = await Promise.all([
        bpiService.GetDetailBpi(record.numdoc),
        adherentsService.getAllAdherents(),
        participantsIpmService.getOneEtParticipant(record.codesoc),
        participantsIpmService.getBenefParticipant(record.matripart),
        typesBenefsService.getAllTypesBenefs(),
        specialistesService.getAllSpecialites(),
        fournisseurService.getAllListFournis(),
        fournisseurService.getAllListFournis(),
        participantsIpmService.getOptiqueList(),
      ]);

      const selectedBenef = benefsData.find(
        (benef) => benef.codetype === details.typebenef
      );
      const codespe = details.codepresc.slice(0, 2);
      const prescripteur = prescripteursData.find(
        (prescripteur) => prescripteur.numFourn === details.codepresc
      );

      // Vérification du délai de prise en charge optique pour le bénéficiaire
      const verifOptique = await participantsIpmService.getVerifOptique(
        details.matribenef
      );

      if (verifOptique.verif === 'Doublon') {
        notification.error({
          message: "Erreur",
          description: "Un Bon Optique est deja etabli pour ce bénéficiaire",
        });
        handleCloseModal();
        return;
      } else if (verifOptique.verif === 'Delai') {
        Modal.confirm({
          title: "Délai de prise en charge optique non épuisé!",
          content: "Voulez-vous continuer?",
          okText: "Valider",
          cancelText: "Annuler",
          onOk: () => {
            const selectedRowData = {
              ...details,
              remise: details.montant_remise,
              datepresc: details.datepresc
                ? dayjs(details.datepresc)
                : undefined,
              datedoc: details.datedoc ? dayjs(details.datedoc) : undefined,
              libtype: selectedBenef ? selectedBenef.libtype : undefined,
              codespe: codespe,
              codepresc: prescripteur ? prescripteur.numFourn : undefined,
              remb_integral: true,
            };

            form.setFieldsValue(selectedRowData);

            const actes = details.actes.map((acte, index) => ({
              ...acte,
              numero: index + 1,
              qte: acte.qte,
              prix_unitaire: acte.prix_unitaire,
              freel: acte.qte * acte.prix_unitaire,
            }));

            dispatch({
              type: "SET_STATE",
              payload: {
                selectedRowData: selectedRowData,
                adherents: adherentsData,
                participantsData: participantsData,
                beneficiaires: benefData,
                benefsData: benefsData,
                specialitesData: specialites,
                prescripteursData: prescripteursData,
                pharmaciesData: pharmaciesData,
                medicamentsData: medicamentsData,
                addedRows: actes,
                addedMedicaments: actes.map((acte) => acte.codeacte),
                isTableVisible: actes.length > 0,
                nextNumero: actes.length + 1,
                isPrescripteurSelectEnabled: true,
                isSaisirMedicamentClicked: true,
                isMatriculeSelected: true,
                isBeneficiaireSelected: true,
                isDateSelected: true,
                ipm: details.qpmut || 0,
                part: details.ticket || 0,
              },
            });
          },
          onCancel: () => {
            // Logic to handle cancellation, if necessary
          },
        });
      } else if (verifOptique.verif === 'OK') {
        const selectedRowData = {
          ...details,
          remise: details.montant_remise,
          datepresc: details.datepresc ? dayjs(details.datepresc) : undefined,
          datedoc: details.datedoc ? dayjs(details.datedoc) : undefined,
          libtype: selectedBenef ? selectedBenef.libtype : undefined,
          codespe: codespe,
          codepresc: prescripteur ? prescripteur.numFourn : undefined,
          remb_integral: false,
        };

        form.setFieldsValue(selectedRowData);

        const actes = details.actes.map((acte, index) => ({
          ...acte,
          numero: index + 1,
          qte: acte.qte,
          prix_unitaire: acte.prix_unitaire,
          freel: acte.freel,
        }));

        dispatch({
          type: "SET_STATE",
          payload: {
            selectedRowData: selectedRowData,
            adherents: adherentsData,
            participantsData: participantsData,
            beneficiaires: benefData,
            benefsData: benefsData,
            specialitesData: specialites,
            prescripteursData: prescripteursData,
            pharmaciesData: pharmaciesData,
            medicamentsData: medicamentsData,
            addedRows: actes,
            addedMedicaments: actes.map((acte) => acte.codeacte),
            isTableVisible: actes.length > 0,
            nextNumero: actes.length + 1,
            isPrescripteurSelectEnabled: true,
            isSaisirMedicamentClicked: true,
            isMatriculeSelected: true,
            isBeneficiaireSelected: true,
            isDateSelected: true,
            ipm: details.qpmut || 0,
            part: details.ticket || 0,
          },
        });
      }
    } catch (error) {
      console.error("Erreur lors de la récupération des détails :", error);
    }
  };

  const userId = localStorage.getItem("login");

  const handleOk = async () => {
    try {
      const values = await form.validateFields();
      const {
        codefourn,
        codepresc,
        codesoc,
        datepresc,
        remise,
        matribenef,
        matripart,
        montdoc,
        typebenef,
      } = values;

      // Vérifier le délai de prise en charge optique
      const verifOptique = await participantsIpmService.getVerifOptique(
        matribenef
      );
      const rembIntegral = verifOptique.verif === 'Delai' ? true : false;

      // Utiliser les détails du participant stockés dans l'état
      const participantDetails = state.participantDetails || {
        categprof: "N/A",
      };

      const newAddedRows = state.addedRows.length > 0 ? state.addedRows : null;
      const montantDoc =
        state.addedRows.length > 0
          ? state.addedRows.reduce((sum, row) => sum + row.freel, 0)
          : 0;
      const completeActe =
        state.addedRows.length > 0 ? state.addedRows[0] : { codeprest: "04" };
      const tauxPCData = state.newPayload
        ? await handleTauxPc(state.newPayload)
        : { qpmut: 0, ticket: 0 };

      const docData = {
        actes: newAddedRows,
        categprof: participantDetails.categprof,
        codefourn: codefourn,
        codepresc: codepresc,
        codeprest: completeActe.codeprest || "04",
        codesoc: codesoc,
        datepresc: datepresc,
        montdoc: montdoc,
        matribenef: matribenef,
        matripart: matripart,
        montant_remise: remise,
        numdoc: isBonManuel ? values.numdoc : null,
        datedoc: isBonManuel ? values.datedoc?.format("YYYY-MM-DD") : null,
        montdoc: montantDoc,
        natprest: completeActe.codeprest || "04",
        qpmut: tauxPCData.qpmut || 0,
        remb_integral: rembIntegral,
        ticket: tauxPCData.ticket || 0,
        typebenef: typebenef,
        typedoc: "BCI",
        user_id: userId,
      };

      // Ajout du document
      const response = await bpiService.AddDoc(docData);

      if (response.Added === false) {
        notification.error({
          message: "Erreur",
          description: "Numéro de bon déjà ajouté.",
        });
      } else {
        handleCloseModalValid();
        fetchDataByOption(state.selectedOption);
        notification.success({
          message: "Succès",
          description: "Le document a été modifié avec succès.",
        });
      }
    } catch (error) {
      console.error(
        "Erreur lors de la validation du formulaire ou de l'ajout du document :",
        error
      );
      notification.error({
        message: "Erreur",
        description:
          "Erreur lors de la validation du formulaire ou de l'ajout du document : " +
          error.message,
      });
    }
  };

  const handleModif = async () => {
    form
      .validateFields()
      .then(async (values) => {
        try {
          // Récupération des détails du document
          const details = await bpiService.GetDetailBpi(
            state.selectedRowData.numdoc
          );
          // Vérifier le délai de prise en charge optique
          const verifOptique = await participantsIpmService.getVerifOptique(
            values.matribenef
          );
          const rembIntegral = verifOptique.verif === 'Delai' ? true : false;

          // Utiliser les détails du participant stockés dans l'état
          const participantDetails = state.participantDetails || {
            categprof: "N/A",
          };
          // Calcul des montants et valeurs conditionnelles
          const newAddedRows =
            state.addedRows.length > 0 ? state.addedRows : details.actes;
          const montantDoc =
            newAddedRows.length > 0
              ? newAddedRows.reduce((sum, row) => sum + row.freel, 0)
              : 0;
          const completeActe =
            newAddedRows.length > 0 ? newAddedRows[0] : { codeprest: "04" };
          const tauxPCData = state.newPayload
            ? await handleTauxPc(state.newPayload)
            : { qpmut: details.qpmut || 0, ticket: details.ticket || 0 };

          // Construction du docData
          const docData = {
            ...details,
            actes: newAddedRows,
            categprof: participantDetails.categprof,
            codefourn: values.codefourn || details.codefourn,
            codepresc: values.codepresc || details.codepresc,
            codeprest: completeActe.codeprest || "04",
            codesoc: values.codesoc || details.codesoc,
            datepresc: values.datepresc
              ? values.datepresc.format("YYYY-MM-DD")
              : details.datepresc,
            datedoc: details.datedoc,
            matribenef: values.matribenef || details.matribenef,
            matripart: values.matripart || details.matripart,
            montant_remise: values.remise || details.remise,
            montdoc: montantDoc,
            natprest: completeActe.codeprest || "04",
            qpmut: tauxPCData.qpmut || 0,
            montdoc: values.montdoc,
            remb_integral: rembIntegral,
            ticket: tauxPCData.ticket || 0,
            typebenef: values.typebenef || details.typebenef,
            typedoc: "BCI",
            user_id: userId,
            numdoc: details.numdoc,
            nbarticle: newAddedRows.length || 0,
          };

          // Mise à jour du document avec les nouvelles données
          await bpiService.UpdateDetailBpi(docData);
          handleCloseModal();
          fetchDataByOption(state.selectedOption);
          notification.success({
            message: "Succès",
            description: "Le document a été modifié avec succès.",
          });
        } catch (error) {
          console.error("Erreur lors de la modification du document :", error);
        }
      })
      .catch((info) => {
        console.log("Validation failed:", info);
      });
  };

  const handleExportClick = () => {
    const columns = Object.keys(state.filteredData[0] || {});
    dispatch({ type: "SET_STATE", payload: { selectedColumns: columns } });
    dispatch({ type: "SET_STATE", payload: { isExportModalVisible: true } });
  };

  const handleExportModalOk = () => {
    const dataToExport = state.filteredData.map((row) => {
      const rowData = {};
      state.selectedColumns.forEach((column) => {
        rowData[column] = row[column];
      });
      return rowData;
    });

    const worksheet = XLSX.utils.json_to_sheet(dataToExport);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "ExportData");

    XLSX.writeFile(workbook, "export.xlsx");
    dispatch({ type: "SET_STATE", payload: { isExportModalVisible: false } });
  };

  const handleExportModalCancel = () => {
    dispatch({ type: "SET_STATE", payload: { isExportModalVisible: false } });
  };

  const handleColumnChange = (checkedValues) => {
    dispatch({
      type: "SET_STATE",
      payload: { selectedColumns: checkedValues },
    });
  };
  const formatNumberWithSeparator = (number) => {
    return number ? number.toLocaleString() : "0";
  };
  return (
    <div>
      <Card>
        <Row
          justify="space-between"
          align="middle"
          style={{ marginBottom: "40px" }}
        >
          <Col>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 12,
                padding: "10px 20px",
                background: "linear-gradient(135deg, #1890ff 0%, #0097e6 100%)",
                borderRadius: 10,
                boxShadow: "0 4px 15px rgba(24, 144, 255, 0.3)",
              }}
            >
              <EyeOutlined style={{ fontSize: 22, color: "#fff" }} />
              <span
                style={{
                  fontSize: 18,
                  fontWeight: 600,
                  color: "#fff",
                  letterSpacing: 0.5,
                  margin: 0,
                }}
              >
                Bons Optiques
              </span>
            </div>
          </Col>
          <Col>
            <Select
              bordered={false}
              style={{
                width: 100,
                marginRight: 10,
                borderBottom: "2px solid #030303",
              }}
              onChange={handleYearChange}
              value={state.selectedYear}
            >
              {state.years.map((year) => (
                <Option key={year} value={year}>
                  {year}
                </Option>
              ))}
            </Select>
            <Select
              bordered={false}
              style={{
                width: 200,
                marginRight: 10,
                borderBottom: "2px solid #030303",
              }}
              onChange={handleSelectChange}
              value={state.selectedOption}
            >
              <Option value="AA">Tous les Documents</Option>
              <Option value="OK">Traité</Option>
              <Option value="KO">Non Traité</Option>
            </Select>
            <Input
              placeholder="Recherche..."
              bordered={false}
              style={{
                width: 200,
                marginRight: 10,
                borderBottom: "2px solid #030303",
              }}
              onChange={(e) => handleSearch(e.target.value)}
            />
            <Button
              className="buttonRecep"
              style={{ marginRight: 10 }}
              onClick={() => handleOpenModal(false)}
              icon={<PlusCircleOutlined />}
            >
              Bon de prise en charge
            </Button>
            <Button
              className="ButtonbonManuel"
              style={{ marginRight: 10 }}
              onClick={() => handleOpenModal(true)}
              icon={<PlusCircleOutlined />}
            >
              Bon Facturé
            </Button>

            <Button
              icon={<ExportOutlined />}
              className="buttonExport"
              style={{ marginRight: 10 }}
              onClick={handleExportClick}
            >
              Export
            </Button>
            <Button
              className="buttonRefresh"
              icon={<SyncOutlined />}
              onClick={handleRefresh}
            ></Button>
          </Col>
        </Row>
        <TableDOc
          size="small"
          scroll={{ x: true }}
          style={{ cursor: "pointer", whiteSpace: "nowrap", width: "100%" }}
          className="custom-header1-table"
          showSorterTooltip={false}
          bordered
          isPharmacieComponent={false}
          loading={state.loading}
          dataSource={state.filteredData}
          showAdditionalColumns={state.selectedOption === "OK"}
          handleDeleteline={handleDeleteline}
          onEdit={handleEdit}
        />
        <Modal
          open={state.isModalVisible}
          maskClosable={false}
          style={{ top: 20 }}
          footer={null}
          onCancel={handleCloseModal}
          width={1000}
          className="modal-header"
          title={
            <div>
              {state.isEdit
                ? "Modification bon de commande optique"
                : "Création Bon Optique"}
              {state.isEdit && (
                <div style={{ fontSize: "14px", marginTop: "2px" }}>
                  Numéro :{" "}
                  {state.selectedRowData ? state.selectedRowData.numdoc : ""}
                </div>
              )}
            </div>
          }
        >
          <Form form={form} layout="vertical" preserve={false}>
            {isBonManuel && (
              <Row gutter={16}>
                <Divider orientation="left">
                  Infos Bon
                </Divider>

                <>
                  <Col span={8}>
                    <Form.Item
                      name="numdoc"
                      label="Numéro Bon"
                      rules={[
                        {
                          required: true,
                          message: "Veuillez entrer le numéro du bon",
                        },
                      ]}
                    >
                      <Input />
                    </Form.Item>
                  </Col>
                  <Col span={8}>
                    <Form.Item
                      name="datedoc"
                      label="Date Bon"
                      rules={[
                        {
                          required: true,
                          message: "Veuillez sélectionner la date du bon",
                        },
                      ]}
                    >
                      <DatePicker
                        format="DD/MM/YYYY"
                        disabledDate={(current) =>
                          current && current > moment().endOf("day")
                        }
                        style={{ width: "100%" }}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={8}>
                    <Form.Item
                      name="montdoc"
                      label="Montant Bon"
                      initialValue={0}
                    >
                      <InputNumber style={{ width: "100%" }} />
                    </Form.Item>
                  </Col>
                </>
              </Row>
            )}
            <Row gutter={16}>
              <Col span={12}>
                <Divider orientation="left">
                  Participant
                </Divider>
                <Form.Item
                  name="codesoc"
                  label="Société"
                  rules={[
                    {
                      required: true,
                      message: "Veuillez sélectionner une société",
                    },
                  ]}
                >
                  <Select
                    style={{ width: "100%" }}
                    defaultValue={"--Selectionner--"}
                    onChange={handleSocieteChange}
                    disabled={state.isEdit}
                    showSearch
                    filterOption={(input, option) =>
                      option.children
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                  >
                    {state.adherents.map((adherent) => (
                      <Option key={adherent.codeadht} value={adherent.codeadht}>
                        {`${adherent.codeadht} - ${adherent.intitule}`}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
                <Form.Item
                  name="matripart"
                  label="Matricule participant"
                  rules={[
                    {
                      required: true,
                      message: "Veuillez sélectionner une option",
                    },
                  ]}
                >
                  <Select
                    defaultValue={"--Selectionner--"}
                    style={{ width: "100%" }}
                    disabled={!state.participantsData || state.isEdit}
                    onChange={handleMatPartChange}
                    showSearch
                    filterOption={(input, option) =>
                      option.children
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                  >
                    {state.participantsData &&
                      state.participantsData.map((participant) => (
                        <Option
                          key={participant.numcont}
                          value={participant.numcont}
                        >
                          {`${participant.matricule} - ${state.isEdit
                            ? participant.prenom + " " + participant.nom
                            : participant.part
                            }`}
                        </Option>
                      ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={12}>
                <Divider orientation="left">
                  Fournisseur
                </Divider>
                <Form.Item
                  name="codefourn"
                  label="Prestataire"
                  rules={[
                    {
                      required: true,
                      message: "Veuillez sélectionner un prestataire",
                    },
                  ]}
                >
                  <Select
                    style={{ width: "100%" }}
                    defaultValue={"--Selectionner"}
                    onChange={handleFournisChange}
                    showSearch
                    filterOption={(input, option) =>
                      option.children
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                  >
                    {state.pharmaciesData &&
                      state.pharmaciesData.map((pharmacie) => (
                        <Option
                          key={pharmacie.numFourn}
                          value={pharmacie.numFourn}
                        >
                          {`${pharmacie.numFourn} - ${pharmacie.raisoc}`}
                        </Option>
                      ))}
                  </Select>
                </Form.Item>

                <Form.Item name="datepresc" label="Date prescription">
                  <DatePicker
                    format="DD/MM/YYYY"
                    style={{ width: "100%" }}
                    disabled={!state.isPrescripteurSelect && !state.isEdit}
                    disabledDate={(current) =>
                      current && current > moment().endOf("day")
                    }
                    /*  onChange={(value) =>
                      dispatch({
                        type: "SET_STATE",
                        payload: { isDateSelected: !!value },
                      })
                    } */
                    onChange={handleDatePrescChange}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col span={12}>
                <Divider orientation="left">
                  Bénéficiaire
                </Divider>
                <Row gutter={16}>
                  <Col span={12}>
                    <Form.Item
                      name="typebenef"
                      label="Types"
                      rules={[
                        {
                          required: true,
                          message: "Veuillez sélectionner une option",
                        },
                      ]}
                    >
                      <Select
                        style={{ width: "100%" }}
                        disabled={!state.isMatriculeSelected && !state.isEdit}
                        defaultValue="--Selectionner--"
                        onChange={handleTypeBenefChange}
                        showSearch
                        filterOption={(input, option) =>
                          option.children
                            .toLowerCase()
                            .includes(input.toLowerCase())
                        }
                      >
                        {state.benefsData &&
                          state.benefsData.map((benefData) => (
                            <Option
                              key={benefData.codetype}
                              value={benefData.codetype}
                            >
                              {`${benefData.libtype} `}
                            </Option>
                          ))}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item
                      name="matribenef"
                      label="Bénéficiaire"
                      rules={[
                        {
                          required: true,
                          message: "Veuillez sélectionner une option",
                        },
                      ]}
                    >
                      <Select
                        onChange={(value) => {
                          onChangeMatribenef(value);
                        }}


                        style={{ width: "100%" }}
                        disabled={
                          !state.isBeneficiaireSelected && !state.isEdit
                        }
                        showSearch
                        filterOption={(input, option) =>
                          option.children
                            .toLowerCase()
                            .includes(input.toLowerCase())
                        }
                      >
                        {(state.beneficiaires || []).map((beneficiaire) => (
                          <Option
                            key={beneficiaire.matribenef}
                            value={beneficiaire.matribenef}
                          >
                            {`${beneficiaire.matribenef} - ${beneficiaire.prenoms
                              ? beneficiaire.prenoms + " "
                              : ""
                              }${beneficiaire.nom ? beneficiaire.nom : ""}`}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                </Row>
                <Divider orientation="left">
                  Prescripteur
                </Divider>
                <Form.Item name="codespe" label="Spécialité">
                  <Select
                    style={{ width: "100%" }}
                    defaultValue="--Selectionner--"
                    onChange={handleFournisseurChange}
                    showSearch
                    allowClear={false}
                    filterOption={(input, option) =>
                      option.children
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                  >
                    {state.specialitesData &&
                      state.specialitesData
                        .filter((specialite) =>
                          ["13"].includes(specialite.codespe)
                        )
                        .map((specialite) => (
                          <Option
                            key={specialite.codespe}
                            value={specialite.codespe}
                          >
                            {` ${specialite.intitule}`}
                          </Option>
                        ))}
                  </Select>
                </Form.Item>
                <Form.Item name="codepresc" label="prescripteur">
                  <Select
                    defaultValue="--Selectionner--"
                    style={{ width: "100%" }}
                    showSearch
                    filterOption={(input, option) =>
                      option.children
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                  >
                    {state.prescripteursData.map((prescripteur) => (
                      <Option
                        key={prescripteur.numFourn}
                        value={prescripteur.numFourn}
                      >
                        {`${prescripteur.numFourn} - ${prescripteur.raisoc}`}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={12}>
                <Divider orientation="left">
                  Actes
                </Divider>
                <Row gutter={16}>
                  <Col span={8}>
                    <Form.Item
                      name="remise"
                      label="Remise"
                      className={
                        state.isSaisirMedicamentClicked ? "" : "hidden"
                      }
                      initialValue={0}
                    >
                      <InputNumber style={{ width: "100%" }} />
                    </Form.Item>
                  </Col>
                  <Col span={8}>
                    <Form.Item
                      name="nbarticle"
                      label="Nb.Article"
                      className={
                        state.isSaisirMedicamentClicked ? "" : "hidden"
                      }
                      initialValue={0}
                    >
                      <InputNumber style={{ width: "100%" }} />
                    </Form.Item>
                  </Col>
                  <Col span={8}>
                    <Form.Item
                      name="qteTotal"
                      label="Quantité Total"
                      className={
                        state.isSaisirMedicamentClicked ? "" : "hidden"
                      }
                      initialValue={0}
                    >
                      <InputNumber style={{ width: "100%" }} />
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={16}>
                  <Col span={16}>
                    <Form.Item name="codeacte">
                      <Select
                        style={{ width: "100%", marginTop: "30px" }}
                        defaultValue="Saisir les actes"
                        disabled={
                          (!state.isPrescripteurSelect ||
                            !state.isDateSelected) &&
                          !state.isEdit
                        }
                        onChange={handleMedoc}
                        showSearch
                        filterOption={(input, option) =>
                          option.children
                            .toLowerCase()
                            .includes(input.toLowerCase())
                        }
                      >
                        {state.medicamentsData &&
                          state.medicamentsData.map((medicament) => (
                            <Option
                              key={medicament.codeacte}
                              value={medicament.codeacte}
                            >
                              {`${medicament.libacte} `}
                            </Option>
                          ))}
                      </Select>
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={16}>
                  <Col span={6}>
                    <Form.Item
                      name="qte"
                      label="Qté"
                      className={
                        state.isSaisirMedicamentClicked ? "" : "hidden"
                      }
                    >
                      <InputNumber defaultValue={1} />
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item
                      name="prix_unitaire"
                      label="P.U"
                      className={
                        state.isSaisirMedicamentClicked ? "" : "hidden"
                      }
                    >
                      <InputNumber
                        defaultValue={0}
                        onChange={(value) => {
                          const numeroLigne = state.addedRows.length + 1;
                          setPrixUnitaireMap((prev) => ({
                            ...prev,
                            [numeroLigne]: value,
                          }));
                        }}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <PlusCircleOutlined
                      style={{
                        fontSize: "30px",
                        paddingTop: "30px",
                        color: "#4DBD74",
                      }}
                      className={
                        state.isSaisirMedicamentClicked ? "" : "hidden"
                      }
                      onClick={handleAddRow}
                    />
                    <CloseCircleFilled
                      style={{
                        fontSize: "30px",
                        paddingTop: "30px",
                        paddingLeft: "8px",
                        color: "#ff2317",
                      }}
                      className={
                        state.isSaisirMedicamentClicked ? "" : "hidden"
                      }
                      onClick={handleClearTable}
                    />
                  </Col>
                </Row>
                {state.isTableVisible && (
                  <Table
                    style={{
                      cursor: "pointer",
                      whiteSpace: "nowrap",
                      width: "100%",
                    }}
                    /*   footer={<div>
                    IPM: - PART: 
                    </div>} */
                    className="custom-header1-table"
                    bordered
                    dataSource={[...state.addedRows]}
                    scroll={{ x: true }}
                    columns={[
                      {
                        title: "N°",
                        dataIndex: "numero",
                        key: "numero",
                        align: "center",
                      },
                      {
                        title: "Nom",
                        dataIndex: "libacte",
                        key: "libacte",
                      },
                      {
                        title: "Qt",
                        dataIndex: "qte",
                        key: "qte",
                        align: "center",
                      },
                      {
                        title: "P.U",
                        dataIndex: "prix_unitaire",
                        key: "prix_unitaire",
                        align: "right",
                        render: (text) => (
                          <strong>{formatNumberWithSeparator(text)}</strong>
                        ),
                      },

                      {
                        title: "Montant",
                        dataIndex: "freel",
                        key: "freel",
                        align: "right",
                        render: (text) => (
                          <strong>{formatNumberWithSeparator(text)}</strong>
                        ),
                      },
                      {
                        title: "Exclus",
                        dataIndex: "exclus",
                        key: "exclus",
                        align: "center",
                        render: (text, record) => (
                          <Checkbox checked={record.exclus} />
                        ),
                      },
                      {
                        title: (
                          <div
                            style={{
                              backgroundColor: "#010f1c",
                              color: "white",
                              padding: "1px",
                            }}
                          ></div>
                        ),
                        dataIndex: "actions",
                        key: "actions",
                        align: "center",
                        fixed: "right",
                        render: (text, record) => (
                          <span>
                            <Popconfirm
                              title="Êtes-vous sûr de vouloir supprimer cette prestation ?"
                              onConfirm={() => handleDelete(record)}
                              okText="Oui"
                              cancelText="Non"
                            >
                              <Tooltip title="Supprimer">
                                <DeleteFilled
                                  style={{ cursor: "pointer", color: "red" }}
                                />
                              </Tooltip>
                            </Popconfirm>
                          </span>
                        ),
                      },
                    ]}
                    summary={(pageData) => {
                      let totalFreel = 0;
                      pageData.forEach((item) => {
                        totalFreel += item.freel;
                      });
                      return (
                        <Table.Summary.Row align="right" justify>
                          <Table.Summary.Cell index={0}>
                            <strong>Total</strong>
                          </Table.Summary.Cell>
                          <Table.Summary.Cell index={1}></Table.Summary.Cell>
                          <Table.Summary.Cell index={2}></Table.Summary.Cell>
                          <Table.Summary.Cell index={3}></Table.Summary.Cell>
                          <Table.Summary.Cell index={4}>
                            <Text>
                              <strong>
                                {formatNumberWithSeparator(totalFreel)}
                              </strong>
                            </Text>
                          </Table.Summary.Cell>
                        </Table.Summary.Row>
                      );
                    }}
                  />
                )}
                <Form.Item
                  className={state.isSaisirMedicamentClicked ? "" : "hidden"}
                >
                  <div style={{ display: "flex", justifyContent: "end" }}>
                    <strong style={{ color: "green" }}>
                      <h4>
                        IPM: {state.ipm} - PART: {state.part}
                      </h4>{" "}
                    </strong>
                  </div>
                </Form.Item>
              </Col>
            </Row>

            <div
              style={{
                marginTop: "20px",
                textAlign: "right",
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
              }}
            >
              {/*  <Form.Item
                name="remb_integral"
                valuePropName="checked"
                style={{ marginBottom: 0 }}
              >
                <div style={{ display: "flex", alignItems: "center" }}>
                  <span style={{ marginRight: "8px" }}>
                    Remboursement Intégral
                  </span>
                  <Checkbox checked={form.getFieldValue("remb_integral")} />
                </div>
              </Form.Item> */}

              <Form.Item
                name="remb_integral"
                style={{ marginBottom: 0 }}
                valuePropName="checked"
              >
                <Checkbox checked={form.getFieldValue("remb_integral")}>
                  Remboursement Intégral
                </Checkbox>
              </Form.Item>
              <Button
                type="dashed"
                danger
                onClick={handleCloseModal}
                style={{ marginLeft: "16px", marginRight: "8px" }}
              >
                Fermer
              </Button>
              {state.isEdit ? (
                <Button
                  type="primary"
                  style={{ backgroundColor: "#010f1c" }}
                  onClick={handleModif}
                >
                  Modifier
                </Button>
              ) : (
                <Button
                  type="primary"
                  style={{ backgroundColor: "#010f1c" }}
                  onClick={handleOk}
                >
                  Valider
                </Button>
              )}
            </div>
          </Form>
        </Modal>
        <Modal
          open={state.isExportModalVisible}
          onCancel={handleExportModalCancel}
          onOk={handleExportModalOk}
          title="Sélectionner les colonnes à exporter"
        >
          <Checkbox.Group
            style={{ width: "100%" }}
            value={state.selectedColumns}
            onChange={handleColumnChange}
          >
            <Row>
              {state.filteredData && state.filteredData.length > 0 ? (
                Object.keys(state.filteredData[0]).map((col) => (
                  <Col span={8} key={col}>
                    <Checkbox value={col}>{col}</Checkbox>
                  </Col>
                ))
              ) : (
                <Col span={24}>Aucune donnée disponible pour exportation</Col>
              )}
            </Row>
          </Checkbox.Group>
        </Modal>
        <Modal
          visible={isParticipantInactive}
          title="Participant inactif!"
          onCancel={() => {
            setIsParticipantInactive(false);
            setSelectedParticipant(null);
          }}
          footer={
            userProfil === "role_1" || userProfil === "role_2"
              ? [
                <Button
                  key="cancel"
                  onClick={() => {
                    setIsParticipantInactive(false);
                    setSelectedParticipant(null);
                    form.resetFields(["matripart"]);
                  }}
                >
                  Annuler
                </Button>,
                <Button
                  key="confirm"
                  type="primary"
                  onClick={async () => {
                    try {
                      const benefData =
                        await participantsIpmService.getBenefParticipant(
                          selectedParticipant.numcont
                        );
                      dispatch({
                        type: "SET_STATE",
                        payload: { isMatriculeSelected: true },
                      });
                      dispatch({
                        type: "SET_STATE",
                        payload: {
                          allBeneficiaires: benefData,
                          beneficiaires: benefData,
                          isBeneficiaireSelected: false,
                          participantDetails: selectedParticipant,
                        },
                      });
                      form.setFieldsValue({
                        codetype: undefined,
                        matribenef: undefined,
                      });
                    } catch (error) {
                      notification.error({
                        message: "Erreur",
                        description:
                          "Erreur lors de la récupération des bénéficiaires",
                      });
                    } finally {
                      setIsParticipantInactive(false);
                      setSelectedParticipant(null);
                    }
                  }}
                >
                  Valider
                </Button>,
              ]
              : [
                <Button
                  key="ok"
                  type="primary"
                  onClick={() => {
                    setIsParticipantInactive(false);
                    setSelectedParticipant(null);
                    form.resetFields(["matripart"]);
                  }}
                >
                  Ok
                </Button>,
              ]
          }
        >
          <p>Participant inactif! Veuillez confirmer cette opération.</p>
        </Modal>
      </Card>
    </div>
  );
};

export default BonsOptique;
